import * as React from 'react'

import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'

import { Container } from './FeatureFlagLink.styles'

export default function FeatureFlagLink() {
  const ffEnabledForUser = useFeatureFlag(Flags.FEATURE_FLAGS_ENABLED)
  return (
    <>
      {ffEnabledForUser.enabled() && (
        <Container>
          <a href="/feature-flags">Feature Flags</a>
        </Container>
      )}
    </>
  )
}
